import React from "react";
import Button from "components/common/Button";
import Dialog from "@mui/material/Dialog";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import Box from "components/common/Box";

const DialogRejectApprovedCharge = ({ open, handleClose }) => {
  return (
    <>
      <Dialog onClose={handleClose} open={open}>
        <Box
          sx={{
            boxSizing: "border-box",
            justifyContent: "center",
            alignItems: "center",
            width: "230px",
            background: "#FBF9F9",
            border: "1px solid #004AAD",
            borderRadius: "8px",
          }}
        >
          <Stack
            spacing={2}
            sx={{ justifyContent: "center", alignItems: "center", p: 3.5 }}
          >
            <img
              src="../images/Group 67505.png"
              alt="logo"
              style={{ width: "27%" }}
            ></img>
            <Typography
              sx={{
                fontWeight: "700",
                fontSize: " 15px",
                textAlign: "center",
                letterSpacing: "-0.01em",
                color: "#111111",
              }}
            >
              Request Reject Sucessfully!
            </Typography>

            <Button
              sx={{
                justifyContent: "center",
                alignItems: "center",
                width: "150px",
                background: "#0DA861",
                borderRadius: "5px",
                flex: "none",
                order: "0",
                flexGrow: "0",
              }}
              onClick={() => handleClose()}
              children="Ok"
            />
          </Stack>
        </Box>
      </Dialog>
    </>
  );
};

export default DialogRejectApprovedCharge;
